angular.module('mychart').controller('ChartConsentCtrl',
    ['_', '$scope', 'TransitionManager', '$stateParams', 'PatientPortalStorageRepository', 'ConsentService', 'aprgettext', 'toaster',
        function (_, $scope, TransitionManager, $stateParams, PatientPortalStorageRepository, ConsentService, gettext, toaster) {
            'use strict';

            $scope.loading = true;

            var activePatientId = PatientPortalStorageRepository.getActivePatient().id;
            var requestedChartRoute = $stateParams.redirectRoute;

            $scope.model = {
                PatientChartConsent: '',
                AgreeCheckboxText: gettext('I have read the consent form and the above information and I accept the conditions.'),
                ConsentWarningMessage: gettext('Please indicate that you agree with this consent form and press the Agree button to proceed.')
            };

            ConsentService
                .getChartConsent(activePatientId)
                .then(function (data) {
                    $scope.removeHttpError();
                    $scope.model.PatientChartConsent = data;
                })
                .catch(function (response) {
                    $scope.addHttpError(response);
                })
                .finally(function () {
                    $scope.loading = false;
                });

            $scope.disagreeToConsent = function () {
                TransitionManager.transition({appRoute: 'dashboard'}, true);
            };


            $scope.submitForm = function () {
                if ($scope.chartConsentForm.$invalid) {
                    return;
                }

                // $submitted flag
                $scope.submitted = true;

                ConsentService
                    .postChartConsent(activePatientId)
                    .then(function () {
                        $scope.$emit('ShowChartSidebar:updated', true);  // fire event up to MyChartCtrl to show the side bar
                        var transition = {
                            appRoute: requestedChartRoute,
                            opts: {
                                id: activePatientId,
                            },
                        };
                        TransitionManager.transition(transition, true);
                    })
                    .catch(function () {
                        toaster.pop('error', '', gettext('An error occurred during saving'));
                    });

                $scope.submitted = false;
            };

        }]);